import { ErrorMetadata, KazooError } from "@kazoohr/types";

/**
 * Throws if the value isn't truthy
 *
 * */
export function assertIsTruthy<TInput, TMetadata extends ErrorMetadata>(
  value: TInput | undefined | null,
  message: string,
  metadata?: TMetadata
): asserts value is TInput {
  if (!value) {
    throw new KazooError(message, metadata);
  }
}
